import * as providersEnvironment from '#shared/util/providersEnvironment.js';

import { isDeveloperRequest } from '#backend/util/request.js';

/**
 * Provider schema
 * @param {object} data
 * @param {object} data.env
 * @param {object} data.route
 * @param {object} data.request (SERVER ONLY)
 * @param {object} data.response (SERVER ONLY)
 * @returns {object}
 */
export const providerSchema = ({ env, route, request, response }) => {
	const isDeveloper = isDeveloperRequest(request, () => route.query.developer === '1');
	const isTest = isDeveloper && route.query.testOrder === '1';
	const developerEnv = isDeveloper ? route.query.env : '';
	const testOrderEnv = isTest ? route.query.env || providersEnvironment.createString(route.query.provider, env) : '';
	const providersConfig = providersEnvironment.createObject(testOrderEnv || developerEnv || env.providersEnvironment, env);
	const { name, project } = response.locals.regionConfig.provider;
	const { paymentLibrary } = providersConfig[name].variables[project] ?? {};
	return {
		variables: {
			paymentLibrary
		}
	};
};
